export class Manufacturer {
  id?: number;
  name!: string;
}
